import { apiPost } from "../ApiMethod";

export const updateDoorState = async (data) => {
  const response = await apiPost("_doorsUpdateState", data);
  return { ...response };
};
